import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'

export type NavigationItem = {
  data: string
  name: string
  id?: string
}

interface NavigationState {
  navigationHistory: NavigationItem[]
  addNavigation: (item: NavigationItem) => void
  removeNavigation: (fromHere: number) => void
  resetNavigation: () => void
  inTransition: boolean
  setInTransition: (inTransition: boolean) => void
  isHydrated: boolean
}

export const useLevelNavigation = create<
  NavigationState,
  [['zustand/persist', unknown]]
>(
  persist<NavigationState>(
    (set) => ({
      navigationHistory: [],
      inTransition: false,
      isHydrated: false,
      addNavigation: (item: NavigationItem) => {
        set((state) => ({
          navigationHistory: [...state.navigationHistory, item],
        }))
      },
      removeNavigation: (fromHere: number) => {
        set((state) => ({
          navigationHistory: state.navigationHistory.slice(0, fromHere + 1),
        }))
      },
      resetNavigation: () => {
        set({ navigationHistory: [] })
      },
      setInTransition: (inTransition) => {
        set({ inTransition })
      },
    }),
    {
      name: '@cockpitia-level-navigation',
      storage: createJSONStorage(() => sessionStorage),
      onRehydrateStorage: () => (state) => {
        if (state) {
          state.isHydrated = true
        }
      },
    },
  ),
)
